import React, { useState, useEffect, useCallback } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ServiceTransaction from "../../services/ServiceTransaction";
import { useNodesServiceClient } from "../../services/brainflex/NodesServiceClient";
import { UserNodeSpeeches, GetUserNodeSpeechesOutput } from "../../services/brainflex/NodesServiceClient";
import "./Activity.css";

const Activity: React.FC = () => {
  const [tab, setTab] = useState(0);
  const [speechNodes, setSpeechNodes] = useState([] as UserNodeSpeeches[]);

  // Context

  // State

  // Other
  const nodesServiceClient = useNodesServiceClient();

  //function handleMostPlayed() {
  //  window.alert("Most Played tab clicked");
  //}
  
  const handleRecentlyPlayed = useCallback(async () => {
    //window.alert("Recently Played tab clicked");
    try {
      const transaction: ServiceTransaction<GetUserNodeSpeechesOutput> = await nodesServiceClient.getRecentlyPlayedSpeeches("en-GB");
      if (transaction.response.isSuccess) {
        setSpeechNodes(transaction.response.success?.data?.speeches ?? []);
      } else {
        // handle error
      }
    } catch (error) {
      console.error("Error fetching bookmarked speeches: ", error);
    }
  }, [nodesServiceClient]);
  
  const handleBookmarked = useCallback(async () => {
    //window.alert("Bookmarked tab clicked");
    try {
      const transaction: ServiceTransaction<GetUserNodeSpeechesOutput> = await nodesServiceClient.getBookmarkedSpeeches("en-GB");
      if (transaction.response.isSuccess) {
        setSpeechNodes(transaction.response.success?.data?.speeches ?? []);
      } else {
        // handle error
      }
    } catch (error) {
      console.error("Error fetching bookmarked speeches: ", error);
    }
  }, [nodesServiceClient]);

  const handleMostPlayed = useCallback(async () => {
    //window.alert("Most Played tab clicked");
    try {
      const transaction: ServiceTransaction<GetUserNodeSpeechesOutput> = await nodesServiceClient.getMostPlayedSpeeches("en-GB");
      if (transaction.response.isSuccess) {
        setSpeechNodes(transaction.response.success?.data?.speeches ?? []);
      } else {
        // handle error
      }
    } catch (error) {
      console.error("Error fetching bookmarked speeches: ", error);
    }
  }, [nodesServiceClient]);

  useEffect(() => {
    handleMostPlayed();
  }, [handleMostPlayed]);
  
  return (
    <Box>
      <h1>Activity</h1>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label="activity tabs">
        <Tab label="Most Played" onClick={handleMostPlayed} />
        <Tab label="Recently Played" onClick={handleRecentlyPlayed} />
        <Tab label="Bookmarked" onClick={handleBookmarked} />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        <table className="activity-table">
          <thead>
            <tr>
              <th>Node ID</th>
              <th>Source Text</th>
              <th>Locale</th>
              <th>Text</th>
              <th>Voice</th>
              <th>Times Played</th>
              <th>Last Played</th>
              <th>Bookmarked</th>
              <th>Play Rank</th>
            </tr>
          </thead>
          <tbody>
            {speechNodes.map((row:UserNodeSpeeches) => (
              <tr key={row.nodeSpeechId}>
                <td>{row.nodeId}</td>
                <td>{row.sourceText}</td>
                <td>{row.locale}</td>
                <td>{row.text}</td>
                <td>{row.voice}</td>
                <td>{row.timesPlayed}</td>
                <td>{row.lastPlayed ? new Date(row.lastPlayed).toLocaleString() : ''}</td>
                <td>{row.bookmarkedAt ? 'Yes' : 'No'}</td>
                <td>{row.playRank}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};

export default Activity;